import { CaseTypeRepository } from '@telespot/domain';

export interface IDeleteCaseTypeCommand {
  /**
   * Deletes the case type with the given id.
   * Repository errors propagate so callers can decide how to react.
   */
  execute(caseTypeId: string): Promise<void>;
}

export class DeleteCaseTypeCommand implements IDeleteCaseTypeCommand {
  constructor(private readonly caseTypeRepository: CaseTypeRepository) {}

  public async execute(caseTypeId: string): Promise<void> {
    await this.caseTypeRepository.delete(caseTypeId);
  }
}
